export const isCanada = (country?: string) => {
  if (!country) {
    return false
  }
  const _country = country.toLowerCase()
  return _country === "canada" || _country === "can" || _country === "ca"
}

export const isUSA = (country?: string) => {
  if (!country) {
    return false
  }
  const _country = country.toLowerCase()
  return _country === "united states" || _country === "usa" || _country === "us"
}

const cList = [
  {
    alpha2: "AC",
    alpha3: "",
    countryCallingCodes: ["+247"],
    currencies: ["USD"],
    ioc: "SHP",
    languages: ["eng"],
    name: "Ascension Island",
    status: "reserved",
  },
  {
    alpha2: "AD",
    alpha3: "AND",
    countryCallingCodes: ["+376"],
    currencies: ["EUR"],
    ioc: "AND",
    languages: ["cat"],
    name: "Andorra",
    status: "assigned",
  },
  {
    alpha2: "AE",
    alpha3: "ARE",
    countryCallingCodes: ["+971"],
    currencies: ["AED"],
    ioc: "UAE",
    languages: ["ara"],
    name: "United Arab Emirates",
    status: "assigned",
  },
  {
    alpha2: "AF",
    alpha3: "AFG",
    countryCallingCodes: ["+93"],
    currencies: ["AFN"],
    ioc: "AFG",
    languages: ["pus"],
    name: "Afghanistan",
    status: "assigned",
  },
  {
    alpha2: "AG",
    alpha3: "ATG",
    countryCallingCodes: ["+1 268"],
    currencies: ["XCD"],
    ioc: "ANT",
    languages: ["eng"],
    name: "Antigua And Barbuda",
    status: "assigned",
  },
  {
    alpha2: "AI",
    alpha3: "AIA",
    countryCallingCodes: ["+1 264"],
    currencies: ["XCD"],
    ioc: "",
    languages: ["eng"],
    name: "Anguilla",
    status: "assigned",
  },
  {
    alpha2: "AL",
    alpha3: "ALB",
    countryCallingCodes: ["+355"],
    currencies: ["ALL"],
    ioc: "ALB",
    languages: ["alb"],
    name: "Albania",
    status: "assigned",
  },
  {
    alpha2: "AM",
    alpha3: "ARM",
    countryCallingCodes: ["+374"],
    currencies: ["AMD"],
    ioc: "ARM",
    languages: ["arm", "rus"],
    name: "Armenia",
    status: "assigned",
  },
  {
    alpha2: "AO",
    alpha3: "AGO",
    countryCallingCodes: ["+244"],
    currencies: ["AOA"],
    ioc: "ANG",
    languages: ["por"],
    name: "Angola",
    status: "assigned",
  },
  {
    alpha2: "AQ",
    alpha3: "ATA",
    countryCallingCodes: ["+672"],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Antarctica",
    status: "assigned",
  },
  {
    alpha2: "AR",
    alpha3: "ARG",
    countryCallingCodes: ["+54"],
    currencies: ["ARS"],
    ioc: "ARG",
    languages: ["spa"],
    name: "Argentina",
    status: "assigned",
  },
  {
    alpha2: "AS",
    alpha3: "ASM",
    countryCallingCodes: ["+1 684"],
    currencies: ["USD"],
    ioc: "ASA",
    languages: ["eng", "smo"],
    name: "American Samoa",
    status: "assigned",
  },
  {
    alpha2: "AT",
    alpha3: "AUT",
    countryCallingCodes: ["+43"],
    currencies: ["EUR"],
    ioc: "AUT",
    languages: ["ger"],
    name: "Austria",
    status: "assigned",
  },
  {
    alpha2: "AU",
    alpha3: "AUS",
    countryCallingCodes: ["+61"],
    currencies: ["AUD"],
    ioc: "AUS",
    languages: ["eng"],
    name: "Australia",
    status: "assigned",
  },
  {
    alpha2: "AW",
    alpha3: "ABW",
    countryCallingCodes: ["+297"],
    currencies: ["AWG"],
    ioc: "ARU",
    languages: ["dut"],
    name: "Aruba",
    status: "assigned",
  },
  {
    alpha2: "AX",
    alpha3: "ALA",
    countryCallingCodes: ["+358"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["swe"],
    name: "Åland Islands",
    status: "assigned",
  },
  {
    alpha2: "AZ",
    alpha3: "AZE",
    countryCallingCodes: ["+994"],
    currencies: ["AZN"],
    ioc: "AZE",
    languages: ["aze"],
    name: "Azerbaijan",
    status: "assigned",
  },
  {
    alpha2: "BA",
    alpha3: "BIH",
    countryCallingCodes: ["+387"],
    currencies: ["BAM"],
    ioc: "BIH",
    languages: ["bos", "cre", "srp"],
    name: "Bosnia & Herzegovina",
    status: "assigned",
  },
  {
    alpha2: "BB",
    alpha3: "BRB",
    countryCallingCodes: ["+1 246"],
    currencies: ["BBD"],
    ioc: "BAR",
    languages: ["eng"],
    name: "Barbados",
    status: "assigned",
  },
  {
    alpha2: "BD",
    alpha3: "BGD",
    countryCallingCodes: ["+880"],
    currencies: ["BDT"],
    ioc: "BAN",
    languages: ["ben"],
    name: "Bangladesh",
    status: "assigned",
  },
  {
    alpha2: "BE",
    alpha3: "BEL",
    countryCallingCodes: ["+32"],
    currencies: ["EUR"],
    ioc: "BEL",
    languages: ["dut", "fre", "ger"],
    name: "Belgium",
    status: "assigned",
  },
  {
    alpha2: "BF",
    alpha3: "BFA",
    countryCallingCodes: ["+226"],
    currencies: ["XOF"],
    ioc: "BUR",
    languages: ["fre"],
    name: "Burkina Faso",
    status: "assigned",
  },
  {
    alpha2: "BG",
    alpha3: "BGR",
    countryCallingCodes: ["+359"],
    currencies: ["BGN"],
    ioc: "BUL",
    languages: ["bul"],
    name: "Bulgaria",
    status: "assigned",
  },
  {
    alpha2: "BH",
    alpha3: "BHR",
    countryCallingCodes: ["+973"],
    currencies: ["BHD"],
    ioc: "BRN",
    languages: ["ara"],
    name: "Bahrain",
    status: "assigned",
  },
  {
    alpha2: "BI",
    alpha3: "BDI",
    countryCallingCodes: ["+257"],
    currencies: ["BIF"],
    ioc: "BDI",
    languages: ["fre"],
    name: "Burundi",
    status: "assigned",
  },
  {
    alpha2: "BJ",
    alpha3: "BEN",
    countryCallingCodes: ["+229"],
    currencies: ["XOF"],
    ioc: "BEN",
    languages: ["fre"],
    name: "Benin",
    status: "assigned",
  },
  {
    alpha2: "BL",
    alpha3: "BLM",
    countryCallingCodes: ["+590"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "Saint Barthélemy",
    status: "assigned",
  },
  {
    alpha2: "BM",
    alpha3: "BMU",
    countryCallingCodes: ["+1 441"],
    currencies: ["BMD"],
    ioc: "BER",
    languages: ["eng"],
    name: "Bermuda",
    status: "assigned",
  },
  {
    alpha2: "BN",
    alpha3: "BRN",
    countryCallingCodes: ["+673"],
    currencies: ["BND"],
    ioc: "BRU",
    languages: ["may", "eng"],
    name: "Brunei Darussalam",
    status: "assigned",
  },
  {
    alpha2: "BO",
    alpha3: "BOL",
    countryCallingCodes: ["+591"],
    currencies: ["BOB", "BOV"],
    ioc: "BOL",
    languages: ["spa", "aym", "que"],
    name: "Bolivia, Plurinational State Of",
    status: "assigned",
  },
  {
    alpha2: "BQ",
    alpha3: "BES",
    countryCallingCodes: ["+599"],
    currencies: ["USD"],
    ioc: "",
    languages: ["dut"],
    name: "Bonaire, Saint Eustatius And Saba",
    status: "assigned",
  },
  {
    alpha2: "BR",
    alpha3: "BRA",
    countryCallingCodes: ["+55"],
    currencies: ["BRL"],
    ioc: "BRA",
    languages: ["por"],
    name: "Brazil",
    status: "assigned",
  },
  {
    alpha2: "BS",
    alpha3: "BHS",
    countryCallingCodes: ["+1 242"],
    currencies: ["BSD"],
    ioc: "BAH",
    languages: ["eng"],
    name: "Bahamas",
    status: "assigned",
  },
  {
    alpha2: "BT",
    alpha3: "BTN",
    countryCallingCodes: ["+975"],
    currencies: ["INR", "BTN"],
    ioc: "BHU",
    languages: ["dzo"],
    name: "Bhutan",
    status: "assigned",
  },
  {
    alpha2: "BV",
    alpha3: "BVT",
    countryCallingCodes: [],
    currencies: ["NOK"],
    ioc: "",
    languages: [],
    name: "Bouvet Island",
    status: "assigned",
  },
  {
    alpha2: "BW",
    alpha3: "BWA",
    countryCallingCodes: ["+267"],
    currencies: ["BWP"],
    ioc: "BOT",
    languages: ["eng", "tsn"],
    name: "Botswana",
    status: "assigned",
  },
  {
    alpha2: "BY",
    alpha3: "BLR",
    countryCallingCodes: ["+375"],
    currencies: ["BYR"],
    ioc: "BLR",
    languages: ["bel", "rus"],
    name: "Belarus",
    status: "assigned",
  },
  {
    alpha2: "BZ",
    alpha3: "BLZ",
    countryCallingCodes: ["+501"],
    currencies: ["BZD"],
    ioc: "BIZ",
    languages: ["eng"],
    name: "Belize",
    status: "assigned",
  },
  {
    alpha2: "CA",
    alpha3: "CAN",
    countryCallingCodes: ["+1"],
    currencies: ["CAD"],
    ioc: "CAN",
    languages: ["eng", "fre"],
    name: "Canada",
    status: "assigned",
  },
  {
    alpha2: "CC",
    alpha3: "CCK",
    countryCallingCodes: ["+61"],
    currencies: ["AUD"],
    ioc: "",
    languages: ["eng"],
    name: "Cocos (Keeling) Islands",
    status: "assigned",
  },
  {
    alpha2: "CD",
    alpha3: "COD",
    countryCallingCodes: ["+243"],
    currencies: ["CDF"],
    ioc: "COD",
    languages: ["fre", "lin", "kon", "swa"],
    name: "Democratic Republic Of Congo",
    status: "assigned",
  },
  {
    alpha2: "CF",
    alpha3: "CAF",
    countryCallingCodes: ["+236"],
    currencies: ["XAF"],
    ioc: "CAF",
    languages: ["fre", "sag"],
    name: "Central African Republic",
    status: "assigned",
  },
  {
    alpha2: "CG",
    alpha3: "COG",
    countryCallingCodes: ["+242"],
    currencies: ["XAF"],
    ioc: "CGO",
    languages: ["fre", "lin"],
    name: "Republic Of Congo",
    status: "assigned",
  },
  {
    alpha2: "CH",
    alpha3: "CHE",
    countryCallingCodes: ["+41"],
    currencies: ["CHF", "CHE", "CHW"],
    ioc: "SUI",
    languages: ["ger", "fre", "ita", "roh"],
    name: "Switzerland",
    status: "assigned",
  },
  {
    alpha2: "CI",
    alpha3: "CIV",
    countryCallingCodes: ["+225"],
    currencies: ["XOF"],
    ioc: "CIV",
    languages: ["fre"],
    name: "Cote d'Ivoire",
    status: "assigned",
  },
  {
    alpha2: "CK",
    alpha3: "COK",
    countryCallingCodes: ["+682"],
    currencies: ["NZD"],
    ioc: "COK",
    languages: ["eng", "mao"],
    name: "Cook Islands",
    status: "assigned",
  },
  {
    alpha2: "CL",
    alpha3: "CHL",
    countryCallingCodes: ["+56"],
    currencies: ["CLP", "CLF"],
    ioc: "CHI",
    languages: ["spa"],
    name: "Chile",
    status: "assigned",
  },
  {
    alpha2: "CM",
    alpha3: "CMR",
    countryCallingCodes: ["+237"],
    currencies: ["XAF"],
    ioc: "CMR",
    languages: ["eng", "fre"],
    name: "Cameroon",
    status: "assigned",
  },
  {
    alpha2: "CN",
    alpha3: "CHN",
    countryCallingCodes: ["+86"],
    currencies: ["CNY"],
    ioc: "CHN",
    languages: ["chi"],
    name: "China",
    status: "assigned",
  },
  {
    alpha2: "CO",
    alpha3: "COL",
    countryCallingCodes: ["+57"],
    currencies: ["COP", "COU"],
    ioc: "COL",
    languages: ["spa"],
    name: "Colombia",
    status: "assigned",
  },
  {
    alpha2: "CP",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["EUR"],
    ioc: "",
    languages: [],
    name: "Clipperton Island",
    status: "reserved",
  },
  {
    alpha2: "CR",
    alpha3: "CRI",
    countryCallingCodes: ["+506"],
    currencies: ["CRC"],
    ioc: "CRC",
    languages: ["spa"],
    name: "Costa Rica",
    status: "assigned",
  },
  {
    alpha2: "CU",
    alpha3: "CUB",
    countryCallingCodes: ["+53"],
    currencies: ["CUP", "CUC"],
    ioc: "CUB",
    languages: ["spa"],
    name: "Cuba",
    status: "assigned",
  },
  {
    alpha2: "CV",
    alpha3: "CPV",
    countryCallingCodes: ["+238"],
    currencies: ["CVE"],
    ioc: "CPV",
    languages: ["por"],
    name: "Cabo Verde",
    status: "assigned",
  },
  {
    alpha2: "CW",
    alpha3: "CUW",
    countryCallingCodes: ["+599"],
    currencies: ["ANG"],
    ioc: "",
    languages: ["dut"],
    name: "Curacao",
    status: "assigned",
  },
  {
    alpha2: "CX",
    alpha3: "CXR",
    countryCallingCodes: ["+61"],
    currencies: ["AUD"],
    ioc: "",
    languages: ["eng"],
    name: "Christmas Island",
    status: "assigned",
  },
  {
    alpha2: "CY",
    alpha3: "CYP",
    countryCallingCodes: ["+357"],
    currencies: ["EUR"],
    ioc: "CYP",
    languages: ["gre", "tur"],
    name: "Cyprus",
    status: "assigned",
  },
  {
    alpha2: "CZ",
    alpha3: "CZE",
    countryCallingCodes: ["+420"],
    currencies: ["CZK"],
    ioc: "CZE",
    languages: ["cze"],
    name: "Czech Republic",
    status: "assigned",
  },
  {
    alpha2: "DE",
    alpha3: "DEU",
    countryCallingCodes: ["+49"],
    currencies: ["EUR"],
    ioc: "GER",
    languages: ["ger"],
    name: "Germany",
    status: "assigned",
  },
  {
    alpha2: "DG",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["USD"],
    ioc: "",
    languages: [],
    name: "Diego Garcia",
    status: "reserved",
  },
  {
    alpha2: "DJ",
    alpha3: "DJI",
    countryCallingCodes: ["+253"],
    currencies: ["DJF"],
    ioc: "DJI",
    languages: ["ara", "fre"],
    name: "Djibouti",
    status: "assigned",
  },
  {
    alpha2: "DK",
    alpha3: "DNK",
    countryCallingCodes: ["+45"],
    currencies: ["DKK"],
    ioc: "DEN",
    languages: ["dan"],
    name: "Denmark",
    status: "assigned",
  },
  {
    alpha2: "DM",
    alpha3: "DMA",
    countryCallingCodes: ["+1 767"],
    currencies: ["XCD"],
    ioc: "DMA",
    languages: ["eng"],
    name: "Dominica",
    status: "assigned",
  },
  {
    alpha2: "DO",
    alpha3: "DOM",
    countryCallingCodes: ["+1 809", "+1 829", "+1 849"],
    currencies: ["DOP"],
    ioc: "DOM",
    languages: ["spa"],
    name: "Dominican Republic",
    status: "assigned",
  },
  {
    alpha2: "DZ",
    alpha3: "DZA",
    countryCallingCodes: ["+213"],
    currencies: ["DZD"],
    ioc: "ALG",
    languages: ["ara"],
    name: "Algeria",
    status: "assigned",
  },
  {
    alpha2: "EA",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["EUR"],
    ioc: "",
    languages: [],
    name: "Ceuta, Mulilla",
    status: "reserved",
  },
  {
    alpha2: "EC",
    alpha3: "ECU",
    countryCallingCodes: ["+593"],
    currencies: ["USD"],
    ioc: "ECU",
    languages: ["spa", "que"],
    name: "Ecuador",
    status: "assigned",
  },
  {
    alpha2: "EE",
    alpha3: "EST",
    countryCallingCodes: ["+372"],
    currencies: ["EUR"],
    ioc: "EST",
    languages: ["est"],
    name: "Estonia",
    status: "assigned",
  },
  {
    alpha2: "EG",
    alpha3: "EGY",
    countryCallingCodes: ["+20"],
    currencies: ["EGP"],
    ioc: "EGY",
    languages: ["ara"],
    name: "Egypt",
    status: "assigned",
  },
  {
    alpha2: "EH",
    alpha3: "ESH",
    countryCallingCodes: ["+212"],
    currencies: ["MAD"],
    ioc: "",
    languages: [],
    name: "Western Sahara",
    status: "assigned",
  },
  {
    alpha2: "ER",
    alpha3: "ERI",
    countryCallingCodes: ["+291"],
    currencies: ["ERN"],
    ioc: "ERI",
    languages: ["eng", "ara", "tir"],
    name: "Eritrea",
    status: "assigned",
  },
  {
    alpha2: "ES",
    alpha3: "ESP",
    countryCallingCodes: ["+34"],
    currencies: ["EUR"],
    ioc: "ESP",
    languages: ["spa"],
    name: "Spain",
    status: "assigned",
  },
  {
    alpha2: "ET",
    alpha3: "ETH",
    countryCallingCodes: ["+251"],
    currencies: ["ETB"],
    ioc: "ETH",
    languages: ["amh"],
    name: "Ethiopia",
    status: "assigned",
  },
  {
    alpha2: "EU",
    alpha3: "",
    countryCallingCodes: ["+388"],
    currencies: ["EUR"],
    ioc: "",
    languages: [],
    name: "European Union",
    status: "reserved",
  },
  {
    alpha2: "FI",
    alpha3: "FIN",
    countryCallingCodes: ["+358"],
    currencies: ["EUR"],
    ioc: "FIN",
    languages: ["fin", "swe"],
    name: "Finland",
    status: "assigned",
  },
  {
    alpha2: "FJ",
    alpha3: "FJI",
    countryCallingCodes: ["+679"],
    currencies: ["FJD"],
    ioc: "FIJ",
    languages: ["eng", "fij"],
    name: "Fiji",
    status: "assigned",
  },
  {
    alpha2: "FK",
    alpha3: "FLK",
    countryCallingCodes: ["+500"],
    currencies: ["FKP"],
    ioc: "",
    languages: ["eng"],
    name: "Falkland Islands",
    status: "assigned",
  },
  {
    alpha2: "FM",
    alpha3: "FSM",
    countryCallingCodes: ["+691"],
    currencies: ["USD"],
    ioc: "",
    languages: ["eng"],
    name: "Micronesia, Federated States Of",
    status: "assigned",
  },
  {
    alpha2: "FO",
    alpha3: "FRO",
    countryCallingCodes: ["+298"],
    currencies: ["DKK"],
    ioc: "FAI",
    languages: ["fao", "dan"],
    name: "Faroe Islands",
    status: "assigned",
  },
  {
    alpha2: "FR",
    alpha3: "FRA",
    countryCallingCodes: ["+33"],
    currencies: ["EUR"],
    ioc: "FRA",
    languages: ["fre"],
    name: "France",
    status: "assigned",
  },
  {
    alpha2: "GA",
    alpha3: "GAB",
    countryCallingCodes: ["+241"],
    currencies: ["XAF"],
    ioc: "GAB",
    languages: ["fre"],
    name: "Gabon",
    status: "assigned",
  },
  {
    alpha2: "GB",
    alpha3: "GBR",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    ioc: "GBR",
    languages: ["eng", "cor", "gle", "gla", "wel"],
    name: "United Kingdom",
    status: "assigned",
  },
  {
    alpha2: "GD",
    alpha3: "GRD",
    countryCallingCodes: ["+473"],
    currencies: ["XCD"],
    ioc: "GRN",
    languages: ["eng"],
    name: "Grenada",
    status: "assigned",
  },
  {
    alpha2: "GE",
    alpha3: "GEO",
    countryCallingCodes: ["+995"],
    currencies: ["GEL"],
    ioc: "GEO",
    languages: ["geo"],
    name: "Georgia",
    status: "assigned",
  },
  {
    alpha2: "GF",
    alpha3: "GUF",
    countryCallingCodes: ["+594"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "French Guiana",
    status: "assigned",
  },
  {
    alpha2: "GG",
    alpha3: "GGY",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    ioc: "GCI",
    languages: ["fre"],
    name: "Guernsey",
    status: "assigned",
  },
  {
    alpha2: "GH",
    alpha3: "GHA",
    countryCallingCodes: ["+233"],
    currencies: ["GHS"],
    ioc: "GHA",
    languages: ["eng"],
    name: "Ghana",
    status: "assigned",
  },
  {
    alpha2: "GI",
    alpha3: "GIB",
    countryCallingCodes: ["+350"],
    currencies: ["GIP"],
    ioc: "",
    languages: ["eng"],
    name: "Gibraltar",
    status: "assigned",
  },
  {
    alpha2: "GL",
    alpha3: "GRL",
    countryCallingCodes: ["+299"],
    currencies: ["DKK"],
    ioc: "",
    languages: ["kal"],
    name: "Greenland",
    status: "assigned",
  },
  {
    alpha2: "GM",
    alpha3: "GMB",
    countryCallingCodes: ["+220"],
    currencies: ["GMD"],
    ioc: "GAM",
    languages: ["eng"],
    name: "Gambia",
    status: "assigned",
  },
  {
    alpha2: "GN",
    alpha3: "GIN",
    countryCallingCodes: ["+224"],
    currencies: ["GNF"],
    ioc: "GUI",
    languages: ["fre"],
    name: "Guinea",
    status: "assigned",
  },
  {
    alpha2: "GP",
    alpha3: "GLP",
    countryCallingCodes: ["+590"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "Guadeloupe",
    status: "assigned",
  },
  {
    alpha2: "GQ",
    alpha3: "GNQ",
    countryCallingCodes: ["+240"],
    currencies: ["XAF"],
    ioc: "GEQ",
    languages: ["spa", "fre", "por"],
    name: "Equatorial Guinea",
    status: "assigned",
  },
  {
    alpha2: "GR",
    alpha3: "GRC",
    countryCallingCodes: ["+30"],
    currencies: ["EUR"],
    ioc: "GRE",
    languages: ["gre"],
    name: "Greece",
    status: "assigned",
  },
  {
    alpha2: "GS",
    alpha3: "SGS",
    countryCallingCodes: [],
    currencies: ["GBP"],
    ioc: "",
    languages: ["eng"],
    name: "South Georgia And The South Sandwich Islands",
    status: "assigned",
  },
  {
    alpha2: "GT",
    alpha3: "GTM",
    countryCallingCodes: ["+502"],
    currencies: ["GTQ"],
    ioc: "GUA",
    languages: ["spa"],
    name: "Guatemala",
    status: "assigned",
  },
  {
    alpha2: "GU",
    alpha3: "GUM",
    countryCallingCodes: ["+1 671"],
    currencies: ["USD"],
    ioc: "GUM",
    languages: ["eng"],
    name: "Guam",
    status: "assigned",
  },
  {
    alpha2: "GW",
    alpha3: "GNB",
    countryCallingCodes: ["+245"],
    currencies: ["XOF"],
    ioc: "GBS",
    languages: ["por"],
    name: "Guinea-bissau",
    status: "assigned",
  },
  {
    alpha2: "GY",
    alpha3: "GUY",
    countryCallingCodes: ["+592"],
    currencies: ["GYD"],
    ioc: "GUY",
    languages: ["eng"],
    name: "Guyana",
    status: "assigned",
  },
  {
    alpha2: "HK",
    alpha3: "HKG",
    countryCallingCodes: ["+852"],
    currencies: ["HKD"],
    ioc: "HKG",
    languages: ["chi", "eng"],
    name: "Hong Kong",
    status: "assigned",
  },
  {
    alpha2: "HM",
    alpha3: "HMD",
    countryCallingCodes: [],
    currencies: ["AUD"],
    ioc: "",
    languages: [],
    name: "Heard Island And McDonald Islands",
    status: "assigned",
  },
  {
    alpha2: "HN",
    alpha3: "HND",
    countryCallingCodes: ["+504"],
    currencies: ["HNL"],
    ioc: "HON",
    languages: ["spa"],
    name: "Honduras",
    status: "assigned",
  },
  {
    alpha2: "HR",
    alpha3: "HRV",
    countryCallingCodes: ["+385"],
    currencies: ["HRK"],
    ioc: "CRO",
    languages: ["hrv"],
    name: "Croatia",
    status: "assigned",
  },
  {
    alpha2: "HT",
    alpha3: "HTI",
    countryCallingCodes: ["+509"],
    currencies: ["HTG", "USD"],
    ioc: "HAI",
    languages: ["fre", "hat"],
    name: "Haiti",
    status: "assigned",
  },
  {
    alpha2: "HU",
    alpha3: "HUN",
    countryCallingCodes: ["+36"],
    currencies: ["HUF"],
    ioc: "HUN",
    languages: ["hun"],
    name: "Hungary",
    status: "assigned",
  },
  {
    alpha2: "IC",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["EUR"],
    ioc: "",
    languages: [],
    name: "Canary Islands",
    status: "reserved",
  },
  {
    alpha2: "ID",
    alpha3: "IDN",
    countryCallingCodes: ["+62"],
    currencies: ["IDR"],
    ioc: "INA",
    languages: ["ind"],
    name: "Indonesia",
    status: "assigned",
  },
  {
    alpha2: "IE",
    alpha3: "IRL",
    countryCallingCodes: ["+353"],
    currencies: ["EUR"],
    ioc: "IRL",
    languages: ["eng", "gle"],
    name: "Ireland",
    status: "assigned",
  },
  {
    alpha2: "IL",
    alpha3: "ISR",
    countryCallingCodes: ["+972"],
    currencies: ["ILS"],
    ioc: "ISR",
    languages: ["heb", "ara", "eng"],
    name: "Israel",
    status: "assigned",
  },
  {
    alpha2: "IM",
    alpha3: "IMN",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    ioc: "",
    languages: ["eng", "glv"],
    name: "Isle Of Man",
    status: "assigned",
  },
  {
    alpha2: "IN",
    alpha3: "IND",
    countryCallingCodes: ["+91"],
    currencies: ["INR"],
    ioc: "IND",
    languages: ["eng", "hin"],
    name: "India",
    status: "assigned",
  },
  {
    alpha2: "IO",
    alpha3: "IOT",
    countryCallingCodes: ["+246"],
    currencies: ["USD"],
    ioc: "",
    languages: ["eng"],
    name: "British Indian Ocean Territory",
    status: "assigned",
  },
  {
    alpha2: "IQ",
    alpha3: "IRQ",
    countryCallingCodes: ["+964"],
    currencies: ["IQD"],
    ioc: "IRQ",
    languages: ["ara", "kur"],
    name: "Iraq",
    status: "assigned",
  },
  {
    alpha2: "IR",
    alpha3: "IRN",
    countryCallingCodes: ["+98"],
    currencies: ["IRR"],
    ioc: "IRI",
    languages: ["per"],
    name: "Iran, Islamic Republic Of",
    status: "assigned",
  },
  {
    alpha2: "IS",
    alpha3: "ISL",
    countryCallingCodes: ["+354"],
    currencies: ["ISK"],
    ioc: "ISL",
    languages: ["ice"],
    name: "Iceland",
    status: "assigned",
  },
  {
    alpha2: "IT",
    alpha3: "ITA",
    countryCallingCodes: ["+39"],
    currencies: ["EUR"],
    ioc: "ITA",
    languages: ["ita"],
    name: "Italy",
    status: "assigned",
  },
  {
    alpha2: "JE",
    alpha3: "JEY",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    ioc: "JCI",
    languages: ["eng", "fre"],
    name: "Jersey",
    status: "assigned",
  },
  {
    alpha2: "JM",
    alpha3: "JAM",
    countryCallingCodes: ["+1 876"],
    currencies: ["JMD"],
    ioc: "JAM",
    languages: ["eng"],
    name: "Jamaica",
    status: "assigned",
  },
  {
    alpha2: "JO",
    alpha3: "JOR",
    countryCallingCodes: ["+962"],
    currencies: ["JOD"],
    ioc: "JOR",
    languages: ["ara"],
    name: "Jordan",
    status: "assigned",
  },
  {
    alpha2: "JP",
    alpha3: "JPN",
    countryCallingCodes: ["+81"],
    currencies: ["JPY"],
    ioc: "JPN",
    languages: ["jpn"],
    name: "Japan",
    status: "assigned",
  },
  {
    alpha2: "KE",
    alpha3: "KEN",
    countryCallingCodes: ["+254"],
    currencies: ["KES"],
    ioc: "KEN",
    languages: ["eng", "swa"],
    name: "Kenya",
    status: "assigned",
  },
  {
    alpha2: "KG",
    alpha3: "KGZ",
    countryCallingCodes: ["+996"],
    currencies: ["KGS"],
    ioc: "KGZ",
    languages: ["rus"],
    name: "Kyrgyzstan",
    status: "assigned",
  },
  {
    alpha2: "KH",
    alpha3: "KHM",
    countryCallingCodes: ["+855"],
    currencies: ["KHR"],
    ioc: "CAM",
    languages: ["khm"],
    name: "Cambodia",
    status: "assigned",
  },
  {
    alpha2: "KI",
    alpha3: "KIR",
    countryCallingCodes: ["+686"],
    currencies: ["AUD"],
    ioc: "KIR",
    languages: ["eng"],
    name: "Kiribati",
    status: "assigned",
  },
  {
    alpha2: "KM",
    alpha3: "COM",
    countryCallingCodes: ["+269"],
    currencies: ["KMF"],
    ioc: "COM",
    languages: ["ara", "fre"],
    name: "Comoros",
    status: "assigned",
  },
  {
    alpha2: "KN",
    alpha3: "KNA",
    countryCallingCodes: ["+1 869"],
    currencies: ["XCD"],
    ioc: "SKN",
    languages: ["eng"],
    name: "Saint Kitts And Nevis",
    status: "assigned",
  },
  {
    alpha2: "KP",
    alpha3: "PRK",
    countryCallingCodes: ["+850"],
    currencies: ["KPW"],
    ioc: "PRK",
    languages: ["kor"],
    name: "North Korea",
    status: "assigned",
  },
  {
    alpha2: "KR",
    alpha3: "KOR",
    countryCallingCodes: ["+82"],
    currencies: ["KRW"],
    ioc: "KOR",
    languages: ["kor"],
    name: "South Korea",
    status: "assigned",
  },
  {
    alpha2: "KW",
    alpha3: "KWT",
    countryCallingCodes: ["+965"],
    currencies: ["KWD"],
    ioc: "KUW",
    languages: ["ara"],
    name: "Kuwait",
    status: "assigned",
  },
  {
    alpha2: "KY",
    alpha3: "CYM",
    countryCallingCodes: ["+1 345"],
    currencies: ["KYD"],
    ioc: "CAY",
    languages: ["eng"],
    name: "Cayman Islands",
    status: "assigned",
  },
  {
    alpha2: "KZ",
    alpha3: "KAZ",
    countryCallingCodes: ["+7", "+7 6", "+7 7"],
    currencies: ["KZT"],
    ioc: "KAZ",
    languages: ["kaz", "rus"],
    name: "Kazakhstan",
    status: "assigned",
  },
  {
    alpha2: "LA",
    alpha3: "LAO",
    countryCallingCodes: ["+856"],
    currencies: ["LAK"],
    ioc: "LAO",
    languages: ["lao"],
    name: "Lao People's Democratic Republic",
    status: "assigned",
  },
  {
    alpha2: "LB",
    alpha3: "LBN",
    countryCallingCodes: ["+961"],
    currencies: ["LBP"],
    ioc: "LIB",
    languages: ["ara", "arm"],
    name: "Lebanon",
    status: "assigned",
  },
  {
    alpha2: "LC",
    alpha3: "LCA",
    countryCallingCodes: ["+1 758"],
    currencies: ["XCD"],
    ioc: "LCA",
    languages: ["eng"],
    name: "Saint Lucia",
    status: "assigned",
  },
  {
    alpha2: "LI",
    alpha3: "LIE",
    countryCallingCodes: ["+423"],
    currencies: ["CHF"],
    ioc: "LIE",
    languages: ["ger"],
    name: "Liechtenstein",
    status: "assigned",
  },
  {
    alpha2: "LK",
    alpha3: "LKA",
    countryCallingCodes: ["+94"],
    currencies: ["LKR"],
    ioc: "SRI",
    languages: ["sin", "tam"],
    name: "Sri Lanka",
    status: "assigned",
  },
  {
    alpha2: "LR",
    alpha3: "LBR",
    countryCallingCodes: ["+231"],
    currencies: ["LRD"],
    ioc: "LBR",
    languages: ["eng"],
    name: "Liberia",
    status: "assigned",
  },
  {
    alpha2: "LS",
    alpha3: "LSO",
    countryCallingCodes: ["+266"],
    currencies: ["LSL", "ZAR"],
    ioc: "LES",
    languages: ["eng", "sot"],
    name: "Lesotho",
    status: "assigned",
  },
  {
    alpha2: "LT",
    alpha3: "LTU",
    countryCallingCodes: ["+370"],
    currencies: ["EUR"],
    ioc: "LTU",
    languages: ["lit"],
    name: "Lithuania",
    status: "assigned",
  },
  {
    alpha2: "LU",
    alpha3: "LUX",
    countryCallingCodes: ["+352"],
    currencies: ["EUR"],
    ioc: "LUX",
    languages: ["fre", "ger", "ltz"],
    name: "Luxembourg",
    status: "assigned",
  },
  {
    alpha2: "LV",
    alpha3: "LVA",
    countryCallingCodes: ["+371"],
    currencies: ["EUR"],
    ioc: "LAT",
    languages: ["lav"],
    name: "Latvia",
    status: "assigned",
  },
  {
    alpha2: "LY",
    alpha3: "LBY",
    countryCallingCodes: ["+218"],
    currencies: ["LYD"],
    ioc: "LBA",
    languages: ["ara"],
    name: "Libya",
    status: "assigned",
  },
  {
    alpha2: "MA",
    alpha3: "MAR",
    countryCallingCodes: ["+212"],
    currencies: ["MAD"],
    ioc: "MAR",
    languages: ["ara"],
    name: "Morocco",
    status: "assigned",
  },
  {
    alpha2: "MC",
    alpha3: "MCO",
    countryCallingCodes: ["+377"],
    currencies: ["EUR"],
    ioc: "MON",
    languages: ["fre"],
    name: "Monaco",
    status: "assigned",
  },
  {
    alpha2: "MD",
    alpha3: "MDA",
    countryCallingCodes: ["+373"],
    currencies: ["MDL"],
    ioc: "MDA",
    languages: ["rum"],
    name: "Moldova",
    status: "assigned",
  },
  {
    alpha2: "ME",
    alpha3: "MNE",
    countryCallingCodes: ["+382"],
    currencies: ["EUR"],
    ioc: "MNE",
    languages: ["mot"],
    name: "Montenegro",
    status: "assigned",
  },
  {
    alpha2: "MF",
    alpha3: "MAF",
    countryCallingCodes: ["+590"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "Saint Martin",
    status: "assigned",
  },
  {
    alpha2: "MG",
    alpha3: "MDG",
    countryCallingCodes: ["+261"],
    currencies: ["MGA"],
    ioc: "MAD",
    languages: ["fre", "mlg"],
    name: "Madagascar",
    status: "assigned",
  },
  {
    alpha2: "MH",
    alpha3: "MHL",
    countryCallingCodes: ["+692"],
    currencies: ["USD"],
    ioc: "MHL",
    languages: ["eng", "mah"],
    name: "Marshall Islands",
    status: "assigned",
  },
  {
    alpha2: "MK",
    alpha3: "MKD",
    countryCallingCodes: ["+389"],
    currencies: ["MKD"],
    ioc: "MKD",
    languages: ["mac"],
    name: "Macedonia, The Former Yugoslav Republic Of",
    status: "assigned",
  },
  {
    alpha2: "ML",
    alpha3: "MLI",
    countryCallingCodes: ["+223"],
    currencies: ["XOF"],
    ioc: "MLI",
    languages: ["fre"],
    name: "Mali",
    status: "assigned",
  },
  {
    alpha2: "MM",
    alpha3: "MMR",
    countryCallingCodes: ["+95"],
    currencies: ["MMK"],
    ioc: "MYA",
    languages: ["bur"],
    name: "Myanmar",
    status: "assigned",
  },
  {
    alpha2: "MN",
    alpha3: "MNG",
    countryCallingCodes: ["+976"],
    currencies: ["MNT"],
    ioc: "MGL",
    languages: ["mon"],
    name: "Mongolia",
    status: "assigned",
  },
  {
    alpha2: "MO",
    alpha3: "MAC",
    countryCallingCodes: ["+853"],
    currencies: ["MOP"],
    ioc: "MAC",
    languages: ["chi", "por"],
    name: "Macao",
    status: "assigned",
  },
  {
    alpha2: "MP",
    alpha3: "MNP",
    countryCallingCodes: ["+1 670"],
    currencies: ["USD"],
    ioc: "",
    languages: ["eng"],
    name: "Northern Mariana Islands",
    status: "assigned",
  },
  {
    alpha2: "MQ",
    alpha3: "MTQ",
    countryCallingCodes: ["+596"],
    currencies: ["EUR"],
    ioc: "",
    languages: [],
    name: "Martinique",
    status: "assigned",
  },
  {
    alpha2: "MR",
    alpha3: "MRT",
    countryCallingCodes: ["+222"],
    currencies: ["MRO"],
    ioc: "MTN",
    languages: ["ara", "fre"],
    name: "Mauritania",
    status: "assigned",
  },
  {
    alpha2: "MS",
    alpha3: "MSR",
    countryCallingCodes: ["+1 664"],
    currencies: ["XCD"],
    ioc: "",
    languages: [],
    name: "Montserrat",
    status: "assigned",
  },
  {
    alpha2: "MT",
    alpha3: "MLT",
    countryCallingCodes: ["+356"],
    currencies: ["EUR"],
    ioc: "MLT",
    languages: ["mlt", "eng"],
    name: "Malta",
    status: "assigned",
  },
  {
    alpha2: "MU",
    alpha3: "MUS",
    countryCallingCodes: ["+230"],
    currencies: ["MUR"],
    ioc: "MRI",
    languages: ["eng", "fre"],
    name: "Mauritius",
    status: "assigned",
  },
  {
    alpha2: "MV",
    alpha3: "MDV",
    countryCallingCodes: ["+960"],
    currencies: ["MVR"],
    ioc: "MDV",
    languages: ["div"],
    name: "Maldives",
    status: "assigned",
  },
  {
    alpha2: "MW",
    alpha3: "MWI",
    countryCallingCodes: ["+265"],
    currencies: ["MWK"],
    ioc: "MAW",
    languages: ["eng", "nya"],
    name: "Malawi",
    status: "assigned",
  },
  {
    alpha2: "MX",
    alpha3: "MEX",
    countryCallingCodes: ["+52"],
    currencies: ["MXN", "MXV"],
    ioc: "MEX",
    languages: ["spa"],
    name: "Mexico",
    status: "assigned",
  },
  {
    alpha2: "MY",
    alpha3: "MYS",
    countryCallingCodes: ["+60"],
    currencies: ["MYR"],
    ioc: "MAS",
    languages: ["msa", "eng"],
    name: "Malaysia",
    status: "assigned",
  },
  {
    alpha2: "MZ",
    alpha3: "MOZ",
    countryCallingCodes: ["+258"],
    currencies: ["MZN"],
    ioc: "MOZ",
    languages: ["por"],
    name: "Mozambique",
    status: "assigned",
  },
  {
    alpha2: "NA",
    alpha3: "NAM",
    countryCallingCodes: ["+264"],
    currencies: ["NAD", "ZAR"],
    ioc: "NAM",
    languages: ["eng"],
    name: "Namibia",
    status: "assigned",
  },
  {
    alpha2: "NC",
    alpha3: "NCL",
    countryCallingCodes: ["+687"],
    currencies: ["XPF"],
    ioc: "",
    languages: ["fre"],
    name: "New Caledonia",
    status: "assigned",
  },
  {
    alpha2: "NE",
    alpha3: "NER",
    countryCallingCodes: ["+227"],
    currencies: ["XOF"],
    ioc: "NIG",
    languages: ["fre"],
    name: "Niger",
    status: "assigned",
  },
  {
    alpha2: "NF",
    alpha3: "NFK",
    countryCallingCodes: ["+672"],
    currencies: ["AUD"],
    ioc: "",
    languages: ["eng"],
    name: "Norfolk Island",
    status: "assigned",
  },
  {
    alpha2: "NG",
    alpha3: "NGA",
    countryCallingCodes: ["+234"],
    currencies: ["NGN"],
    ioc: "NGR",
    languages: ["eng"],
    name: "Nigeria",
    status: "assigned",
  },
  {
    alpha2: "NI",
    alpha3: "NIC",
    countryCallingCodes: ["+505"],
    currencies: ["NIO"],
    ioc: "NCA",
    languages: ["spa"],
    name: "Nicaragua",
    status: "assigned",
  },
  {
    alpha2: "NL",
    alpha3: "NLD",
    countryCallingCodes: ["+31"],
    currencies: ["EUR"],
    ioc: "NED",
    languages: ["dut"],
    name: "Netherlands",
    status: "assigned",
  },
  {
    alpha2: "NO",
    alpha3: "NOR",
    countryCallingCodes: ["+47"],
    currencies: ["NOK"],
    ioc: "NOR",
    languages: ["nor"],
    name: "Norway",
    status: "assigned",
  },
  {
    alpha2: "NP",
    alpha3: "NPL",
    countryCallingCodes: ["+977"],
    currencies: ["NPR"],
    ioc: "NEP",
    languages: ["nep"],
    name: "Nepal",
    status: "assigned",
  },
  {
    alpha2: "NR",
    alpha3: "NRU",
    countryCallingCodes: ["+674"],
    currencies: ["AUD"],
    ioc: "NRU",
    languages: ["eng", "nau"],
    name: "Nauru",
    status: "assigned",
  },
  {
    alpha2: "NU",
    alpha3: "NIU",
    countryCallingCodes: ["+683"],
    currencies: ["NZD"],
    ioc: "",
    languages: ["eng"],
    name: "Niue",
    status: "assigned",
  },
  {
    alpha2: "NZ",
    alpha3: "NZL",
    countryCallingCodes: ["+64"],
    currencies: ["NZD"],
    ioc: "NZL",
    languages: ["eng"],
    name: "New Zealand",
    status: "assigned",
  },
  {
    alpha2: "OM",
    alpha3: "OMN",
    countryCallingCodes: ["+968"],
    currencies: ["OMR"],
    ioc: "OMA",
    languages: ["ara"],
    name: "Oman",
    status: "assigned",
  },
  {
    alpha2: "PA",
    alpha3: "PAN",
    countryCallingCodes: ["+507"],
    currencies: ["PAB", "USD"],
    ioc: "PAN",
    languages: ["spa"],
    name: "Panama",
    status: "assigned",
  },
  {
    alpha2: "PE",
    alpha3: "PER",
    countryCallingCodes: ["+51"],
    currencies: ["PEN"],
    ioc: "PER",
    languages: ["spa", "aym", "que"],
    name: "Peru",
    status: "assigned",
  },
  {
    alpha2: "PF",
    alpha3: "PYF",
    countryCallingCodes: ["+689"],
    currencies: ["XPF"],
    ioc: "",
    languages: ["fre"],
    name: "French Polynesia",
    status: "assigned",
  },
  {
    alpha2: "PG",
    alpha3: "PNG",
    countryCallingCodes: ["+675"],
    currencies: ["PGK"],
    ioc: "PNG",
    languages: ["eng"],
    name: "Papua New Guinea",
    status: "assigned",
  },
  {
    alpha2: "PH",
    alpha3: "PHL",
    countryCallingCodes: ["+63"],
    currencies: ["PHP"],
    ioc: "PHI",
    languages: ["eng"],
    name: "Philippines",
    status: "assigned",
  },
  {
    alpha2: "PK",
    alpha3: "PAK",
    countryCallingCodes: ["+92"],
    currencies: ["PKR"],
    ioc: "PAK",
    languages: ["urd", "eng"],
    name: "Pakistan",
    status: "assigned",
  },
  {
    alpha2: "PL",
    alpha3: "POL",
    countryCallingCodes: ["+48"],
    currencies: ["PLN"],
    ioc: "POL",
    languages: ["pol"],
    name: "Poland",
    status: "assigned",
  },
  {
    alpha2: "PM",
    alpha3: "SPM",
    countryCallingCodes: ["+508"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["eng"],
    name: "Saint Pierre And Miquelon",
    status: "assigned",
  },
  {
    alpha2: "PN",
    alpha3: "PCN",
    countryCallingCodes: ["+872"],
    currencies: ["NZD"],
    ioc: "",
    languages: ["eng"],
    name: "Pitcairn",
    status: "assigned",
  },
  {
    alpha2: "PR",
    alpha3: "PRI",
    countryCallingCodes: ["+1 787", "+1 939"],
    currencies: ["USD"],
    ioc: "PUR",
    languages: ["spa", "eng"],
    name: "Puerto Rico",
    status: "assigned",
  },
  {
    alpha2: "PS",
    alpha3: "PSE",
    countryCallingCodes: ["+970"],
    currencies: ["JOD", "EGP", "ILS"],
    ioc: "PLE",
    languages: ["ara"],
    name: "Palestinian Territory, Occupied",
    status: "assigned",
  },
  {
    alpha2: "PT",
    alpha3: "PRT",
    countryCallingCodes: ["+351"],
    currencies: ["EUR"],
    ioc: "POR",
    languages: ["por"],
    name: "Portugal",
    status: "assigned",
  },
  {
    alpha2: "PW",
    alpha3: "PLW",
    countryCallingCodes: ["+680"],
    currencies: ["USD"],
    ioc: "PLW",
    languages: ["eng"],
    name: "Palau",
    status: "assigned",
  },
  {
    alpha2: "PY",
    alpha3: "PRY",
    countryCallingCodes: ["+595"],
    currencies: ["PYG"],
    ioc: "PAR",
    languages: ["spa"],
    name: "Paraguay",
    status: "assigned",
  },
  {
    alpha2: "QA",
    alpha3: "QAT",
    countryCallingCodes: ["+974"],
    currencies: ["QAR"],
    ioc: "QAT",
    languages: ["ara"],
    name: "Qatar",
    status: "assigned",
  },
  {
    alpha2: "RE",
    alpha3: "REU",
    countryCallingCodes: ["+262"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "Reunion",
    status: "assigned",
  },
  {
    alpha2: "RO",
    alpha3: "ROU",
    countryCallingCodes: ["+40"],
    currencies: ["RON"],
    ioc: "ROU",
    languages: ["rum"],
    name: "Romania",
    status: "assigned",
  },
  {
    alpha2: "RS",
    alpha3: "SRB",
    countryCallingCodes: ["+381"],
    currencies: ["RSD"],
    ioc: "SRB",
    languages: ["srp"],
    name: "Serbia",
    status: "assigned",
  },
  {
    alpha2: "RU",
    alpha3: "RUS",
    countryCallingCodes: ["+7", "+7 3", "+7 4", "+7 8"],
    currencies: ["RUB"],
    ioc: "RUS",
    languages: ["rus"],
    name: "Russian Federation",
    status: "assigned",
  },
  {
    alpha2: "RW",
    alpha3: "RWA",
    countryCallingCodes: ["+250"],
    currencies: ["RWF"],
    ioc: "RWA",
    languages: ["eng", "fre", "kin"],
    name: "Rwanda",
    status: "assigned",
  },
  {
    alpha2: "SA",
    alpha3: "SAU",
    countryCallingCodes: ["+966"],
    currencies: ["SAR"],
    ioc: "KSA",
    languages: ["ara"],
    name: "Saudi Arabia",
    status: "assigned",
  },
  {
    alpha2: "SB",
    alpha3: "SLB",
    countryCallingCodes: ["+677"],
    currencies: ["SBD"],
    ioc: "SOL",
    languages: ["eng"],
    name: "Solomon Islands",
    status: "assigned",
  },
  {
    alpha2: "SC",
    alpha3: "SYC",
    countryCallingCodes: ["+248"],
    currencies: ["SCR"],
    ioc: "SEY",
    languages: ["eng", "fre"],
    name: "Seychelles",
    status: "assigned",
  },
  {
    alpha2: "SD",
    alpha3: "SDN",
    countryCallingCodes: ["+249"],
    currencies: ["SDG"],
    ioc: "SUD",
    languages: ["ara", "eng"],
    name: "Sudan",
    status: "assigned",
  },
  {
    alpha2: "SE",
    alpha3: "SWE",
    countryCallingCodes: ["+46"],
    currencies: ["SEK"],
    ioc: "SWE",
    languages: ["swe"],
    name: "Sweden",
    status: "assigned",
  },
  {
    alpha2: "SG",
    alpha3: "SGP",
    countryCallingCodes: ["+65"],
    currencies: ["SGD"],
    ioc: "SIN",
    languages: ["eng", "chi", "may", "tam"],
    name: "Singapore",
    status: "assigned",
  },
  {
    alpha2: "SH",
    alpha3: "SHN",
    countryCallingCodes: ["+290"],
    currencies: ["SHP"],
    ioc: "",
    languages: ["eng"],
    name: "Saint Helena, Ascension And Tristan Da Cunha",
    status: "assigned",
  },
  {
    alpha2: "SI",
    alpha3: "SVN",
    countryCallingCodes: ["+386"],
    currencies: ["EUR"],
    ioc: "SLO",
    languages: ["slv"],
    name: "Slovenia",
    status: "assigned",
  },
  {
    alpha2: "SJ",
    alpha3: "SJM",
    countryCallingCodes: ["+47"],
    currencies: ["NOK"],
    ioc: "",
    languages: [],
    name: "Svalbard And Jan Mayen",
    status: "assigned",
  },
  {
    alpha2: "SK",
    alpha3: "SVK",
    countryCallingCodes: ["+421"],
    currencies: ["EUR"],
    ioc: "SVK",
    languages: ["slo"],
    name: "Slovakia",
    status: "assigned",
  },
  {
    alpha2: "SL",
    alpha3: "SLE",
    countryCallingCodes: ["+232"],
    currencies: ["SLL"],
    ioc: "SLE",
    languages: ["eng"],
    name: "Sierra Leone",
    status: "assigned",
  },
  {
    alpha2: "SM",
    alpha3: "SMR",
    countryCallingCodes: ["+378"],
    currencies: ["EUR"],
    ioc: "SMR",
    languages: ["ita"],
    name: "San Marino",
    status: "assigned",
  },
  {
    alpha2: "SN",
    alpha3: "SEN",
    countryCallingCodes: ["+221"],
    currencies: ["XOF"],
    ioc: "SEN",
    languages: ["fre"],
    name: "Senegal",
    status: "assigned",
  },
  {
    alpha2: "SO",
    alpha3: "SOM",
    countryCallingCodes: ["+252"],
    currencies: ["SOS"],
    ioc: "SOM",
    languages: ["som"],
    name: "Somalia",
    status: "assigned",
  },
  {
    alpha2: "SR",
    alpha3: "SUR",
    countryCallingCodes: ["+597"],
    currencies: ["SRD"],
    ioc: "SUR",
    languages: ["dut"],
    name: "Suriname",
    status: "assigned",
  },
  {
    alpha2: "SS",
    alpha3: "SSD",
    countryCallingCodes: ["+211"],
    currencies: ["SSP"],
    ioc: "",
    languages: ["eng"],
    name: "South Sudan",
    status: "assigned",
  },
  {
    alpha2: "ST",
    alpha3: "STP",
    countryCallingCodes: ["+239"],
    currencies: ["STD"],
    ioc: "STP",
    languages: ["por"],
    name: "São Tomé and Príncipe",
    status: "assigned",
  },
  {
    alpha2: "SU",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["RUB"],
    ioc: "",
    languages: ["rus"],
    name: "USSR",
    status: "reserved",
  },
  {
    alpha2: "SV",
    alpha3: "SLV",
    countryCallingCodes: ["+503"],
    currencies: ["USD"],
    ioc: "ESA",
    languages: ["spa"],
    name: "El Salvador",
    status: "assigned",
  },
  {
    alpha2: "SX",
    alpha3: "SXM",
    countryCallingCodes: ["+1 721"],
    currencies: ["ANG"],
    ioc: "",
    languages: ["dut"],
    name: "Sint Maarten",
    status: "assigned",
  },
  {
    alpha2: "SY",
    alpha3: "SYR",
    countryCallingCodes: ["+963"],
    currencies: ["SYP"],
    ioc: "SYR",
    languages: ["ara"],
    name: "Syrian Arab Republic",
    status: "assigned",
  },
  {
    alpha2: "SZ",
    alpha3: "SWZ",
    countryCallingCodes: ["+268"],
    currencies: ["SZL"],
    ioc: "SWZ",
    languages: ["eng", "ssw"],
    name: "Swaziland",
    status: "assigned",
  },
  {
    alpha2: "TA",
    alpha3: "",
    countryCallingCodes: ["+290"],
    currencies: ["GBP"],
    ioc: "",
    languages: [],
    name: "Tristan de Cunha",
    status: "reserved",
  },
  {
    alpha2: "TC",
    alpha3: "TCA",
    countryCallingCodes: ["+1 649"],
    currencies: ["USD"],
    ioc: "",
    languages: ["eng"],
    name: "Turks And Caicos Islands",
    status: "assigned",
  },
  {
    alpha2: "TD",
    alpha3: "TCD",
    countryCallingCodes: ["+235"],
    currencies: ["XAF"],
    ioc: "CHA",
    languages: ["ara", "fre"],
    name: "Chad",
    status: "assigned",
  },
  {
    alpha2: "TF",
    alpha3: "ATF",
    countryCallingCodes: [],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "French Southern Territories",
    status: "assigned",
  },
  {
    alpha2: "TG",
    alpha3: "TGO",
    countryCallingCodes: ["+228"],
    currencies: ["XOF"],
    ioc: "TOG",
    languages: ["fre"],
    name: "Togo",
    status: "assigned",
  },
  {
    alpha2: "TH",
    alpha3: "THA",
    countryCallingCodes: ["+66"],
    currencies: ["THB"],
    ioc: "THA",
    languages: ["tha"],
    name: "Thailand",
    status: "assigned",
  },
  {
    alpha2: "TJ",
    alpha3: "TJK",
    countryCallingCodes: ["+992"],
    currencies: ["TJS"],
    ioc: "TJK",
    languages: ["tgk", "rus"],
    name: "Tajikistan",
    status: "assigned",
  },
  {
    alpha2: "TK",
    alpha3: "TKL",
    countryCallingCodes: ["+690"],
    currencies: ["NZD"],
    ioc: "",
    languages: ["eng"],
    name: "Tokelau",
    status: "assigned",
  },
  {
    alpha2: "TL",
    alpha3: "TLS",
    countryCallingCodes: ["+670"],
    currencies: ["USD"],
    ioc: "TLS",
    languages: ["por"],
    name: "East Timor",
    status: "assigned",
  },
  {
    alpha2: "TM",
    alpha3: "TKM",
    countryCallingCodes: ["+993"],
    currencies: ["TMT"],
    ioc: "TKM",
    languages: ["tuk", "rus"],
    name: "Turkmenistan",
    status: "assigned",
  },
  {
    alpha2: "TN",
    alpha3: "TUN",
    countryCallingCodes: ["+216"],
    currencies: ["TND"],
    ioc: "TUN",
    languages: ["ara"],
    name: "Tunisia",
    status: "assigned",
  },
  {
    alpha2: "TO",
    alpha3: "TON",
    countryCallingCodes: ["+676"],
    currencies: ["TOP"],
    ioc: "TGA",
    languages: ["eng"],
    name: "Tonga",
    status: "assigned",
  },
  {
    alpha2: "TR",
    alpha3: "TUR",
    countryCallingCodes: ["+90"],
    currencies: ["TRY"],
    ioc: "TUR",
    languages: ["tur"],
    name: "Turkey",
    status: "assigned",
  },
  {
    alpha2: "TT",
    alpha3: "TTO",
    countryCallingCodes: ["+1 868"],
    currencies: ["TTD"],
    ioc: "TRI",
    languages: ["eng"],
    name: "Trinidad And Tobago",
    status: "assigned",
  },
  {
    alpha2: "TV",
    alpha3: "TUV",
    countryCallingCodes: ["+688"],
    currencies: ["AUD"],
    ioc: "TUV",
    languages: ["eng"],
    name: "Tuvalu",
    status: "assigned",
  },
  {
    alpha2: "TW",
    alpha3: "TWN",
    countryCallingCodes: ["+886"],
    currencies: ["TWD"],
    ioc: "TPE",
    languages: ["chi"],
    name: "Taiwan",
    status: "assigned",
  },
  {
    alpha2: "TZ",
    alpha3: "TZA",
    countryCallingCodes: ["+255"],
    currencies: ["TZS"],
    ioc: "TAN",
    languages: ["swa", "eng"],
    name: "Tanzania, United Republic Of",
    status: "assigned",
  },
  {
    alpha2: "UA",
    alpha3: "UKR",
    countryCallingCodes: ["+380"],
    currencies: ["UAH"],
    ioc: "UKR",
    languages: ["ukr", "rus"],
    name: "Ukraine",
    status: "assigned",
  },
  {
    alpha2: "UG",
    alpha3: "UGA",
    countryCallingCodes: ["+256"],
    currencies: ["UGX"],
    ioc: "UGA",
    languages: ["eng", "swa"],
    name: "Uganda",
    status: "assigned",
  },
  {
    alpha2: "UM",
    alpha3: "UMI",
    countryCallingCodes: ["+1"],
    currencies: ["USD"],
    ioc: "",
    languages: ["eng"],
    name: "United States Minor Outlying Islands",
    status: "assigned",
  },
  {
    alpha2: "US",
    alpha3: "USA",
    countryCallingCodes: ["+1"],
    currencies: ["USD"],
    ioc: "USA",
    languages: ["eng"],
    name: "United States",
    status: "assigned",
  },
  {
    alpha2: "UY",
    alpha3: "URY",
    countryCallingCodes: ["+598"],
    currencies: ["UYU", "UYI"],
    ioc: "URU",
    languages: ["spa"],
    name: "Uruguay",
    status: "assigned",
  },
  {
    alpha2: "UZ",
    alpha3: "UZB",
    countryCallingCodes: ["+998"],
    currencies: ["UZS"],
    ioc: "UZB",
    languages: ["uzb", "rus"],
    name: "Uzbekistan",
    status: "assigned",
  },
  {
    alpha2: "VA",
    alpha3: "VAT",
    countryCallingCodes: ["+379", "+39"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["ita"],
    name: "Vatican City State",
    status: "assigned",
  },
  {
    alpha2: "VC",
    alpha3: "VCT",
    countryCallingCodes: ["+1 784"],
    currencies: ["XCD"],
    ioc: "VIN",
    languages: ["eng"],
    name: "Saint Vincent And The Grenadines",
    status: "assigned",
  },
  {
    alpha2: "VE",
    alpha3: "VEN",
    countryCallingCodes: ["+58"],
    currencies: ["VEF"],
    ioc: "VEN",
    languages: ["spa"],
    name: "Venezuela, Bolivarian Republic Of",
    status: "assigned",
  },
  {
    alpha2: "VG",
    alpha3: "VGB",
    countryCallingCodes: ["+1 284"],
    currencies: ["USD"],
    ioc: "ISV",
    languages: ["eng"],
    name: "Virgin Islands (British)",
    status: "assigned",
  },
  {
    alpha2: "VI",
    alpha3: "VIR",
    countryCallingCodes: ["+1 340"],
    currencies: ["USD"],
    ioc: "ISV",
    languages: ["eng"],
    name: "Virgin Islands (US)",
    status: "assigned",
  },
  {
    alpha2: "VN",
    alpha3: "VNM",
    countryCallingCodes: ["+84"],
    currencies: ["VND"],
    ioc: "VIE",
    languages: ["vie"],
    name: "Viet Nam",
    status: "assigned",
  },
  {
    alpha2: "VU",
    alpha3: "VUT",
    countryCallingCodes: ["+678"],
    currencies: ["VUV"],
    ioc: "VAN",
    languages: ["bis", "eng", "fre"],
    name: "Vanuatu",
    status: "assigned",
  },
  {
    alpha2: "WF",
    alpha3: "WLF",
    countryCallingCodes: ["+681"],
    currencies: ["XPF"],
    ioc: "",
    languages: ["fre"],
    name: "Wallis And Futuna",
    status: "assigned",
  },
  {
    alpha2: "WS",
    alpha3: "WSM",
    countryCallingCodes: ["+685"],
    currencies: ["WST"],
    ioc: "SAM",
    languages: ["eng", "smo"],
    name: "Samoa",
    status: "assigned",
  },
  {
    alpha2: "YE",
    alpha3: "YEM",
    countryCallingCodes: ["+967"],
    currencies: ["YER"],
    ioc: "YEM",
    languages: ["ara"],
    name: "Yemen",
    status: "assigned",
  },
  {
    alpha2: "YT",
    alpha3: "MYT",
    countryCallingCodes: ["+262"],
    currencies: ["EUR"],
    ioc: "",
    languages: ["fre"],
    name: "Mayotte",
    status: "assigned",
  },
  {
    alpha2: "ZA",
    alpha3: "ZAF",
    countryCallingCodes: ["+27"],
    currencies: ["ZAR"],
    ioc: "RSA",
    languages: ["afr", "eng", "nbl", "som", "tso", "ven", "xho", "zul"],
    name: "South Africa",
    status: "assigned",
  },
  {
    alpha2: "ZM",
    alpha3: "ZMB",
    countryCallingCodes: ["+260"],
    currencies: ["ZMW"],
    ioc: "ZAM",
    languages: ["eng"],
    name: "Zambia",
    status: "assigned",
  },
  {
    alpha2: "ZW",
    alpha3: "ZWE",
    countryCallingCodes: ["+263"],
    currencies: ["USD", "ZAR", "BWP", "GBP", "EUR"],
    ioc: "ZIM",
    languages: ["eng", "sna", "nde"],
    name: "Zimbabwe",
    status: "assigned",
  },
]

const postalValidation = [
  {
    Note:
      "The first two digits (ranging from 10–43) correspond to the province, while the last two digits correspond either to the city/delivery zone (range 01–50) or to the district/delivery zone (range 51–99). Afghanistan Postal code lookup",
    Country: "Afghanistan",
    ISO: "AF",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "With Finland, first two numbers are 22.",
    Country: "Åland Islands",
    ISO: "AX",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "Introduced in 2006, gradually implemented throughout 2007.",
    Country: "Albania",
    ISO: "AL",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "First two as in ISO 3166-2:DZ",
    Country: "Algeria",
    ISO: "DZ",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "U.S. ZIP codes (range 96799)",
    Country: "American Samoa",
    ISO: "AS",
    Format: "NNNNN (optionally NNNNN-NNNN or NNNNN-NNNNNN)",
    Regex: "^\\d{5}(-{1}\\d{4,6})$",
  },
  {
    Note: "Each parish now has its own post code.",
    Country: "Andorra",
    ISO: "AD",
    Format: "CCNNN",
    Regex: "^[Aa][Dd]\\d{3}$",
  },
  {
    Note: "",
    Country: "Angola",
    ISO: "AO",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Single code used for all addresses.",
    Country: "Anguilla",
    ISO: "AI",
    Format: "AI-2640",
    Regex: "^[Aa][I][-][2][6][4][0]$",
  },
  {
    Note: "",
    Country: "Antigua and Barbuda",
    ISO: "AG",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Codigo Postal Argentino (CPA), where the first A is the province code as in ISO 3166-2:AR, the four numbers are the old postal codes, the three last letters indicate a side of the block. Previously NNNN which &#10;o the minimum requirement as of 2006.",
    Country: "Argentina",
    ISO: "AR",
    Format: "1974-1998 NNNN; From 1999 ANNNNAAA",
    Regex: "^\\d{4}|[A-Za-z]\\d{4}[a-zA-Z]{3}$",
  },
  {
    Note: "Previously used NNNNNN system inherited from former Soviet Union.",
    Country: "Armenia",
    ISO: "AM",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Aruba",
    ISO: "AW",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Single code used for all addresses. Part of UK system.",
    Country: "Ascension island",
    ISO: "AC",
    Format: "AAAANAA one code: ASCN 1ZZ",
    Regex: "^[Aa][Ss][Cc][Nn]\\s{0,1}[1][Zz][Zz]$",
  },
  {
    Note: "In general, the first digit identifies the state or territory.",
    Country: "Australia",
    ISO: "AU",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note:
      "The first digit denotes regions, which are partly identical to one of the nine provinces—called Bundesländer; the last the nearest post office in the area.",
    Country: "Austria",
    ISO: "AT",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "Previously used NNNNNN system inherited from former Soviet Union.",
    Country: "Azerbaijan",
    ISO: "AZ",
    Format: "CCNNNN",
    Regex: "^[Aa][Zz]\\d{4}$",
  },
  {
    Note: "",
    Country: "Bahamas",
    ISO: "BS",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Valid post code numbers are 101 to 1216 with gaps in the range. Known as block number (Arabic: رقم المجمع‎) formally. The first digit in NNN format and the first two digits in NNNN format refer to one of the 12 municipalities of the country. PO Box address doesn't need a block number or city name, just the PO Box number followed by the name of the country, Bahrain.",
    Country: "Bahrain",
    ISO: "BH",
    Format: "NNN or NNNN",
    Regex: "^\\d{3,4}$",
  },
  {
    Note: "",
    Country: "Bangladesh",
    ISO: "BD",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note:
      "Only one postal code currently assigned. 11000 applies to the General Post Office building in Cheapside, Bridgetown, to enable delivery to Barbados by global package delivery companies whose software requires a postal code.",
    Country: "Barbados",
    ISO: "BB",
    Format: "CCNNNNN",
    Regex: "^[Aa][Zz]\\d{5}$",
  },
  {
    Note: "Retained system inherited from former Soviet Union.",
    Country: "Belarus",
    ISO: "BY",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "In general, the first digit gives the province.",
    Country: "Belgium",
    ISO: "BE",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Belize",
    ISO: "BZ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Benin",
    ISO: "BJ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "AA NN for street addresses, AA AA for P.O. Box addresses. The second half of the postcode identifies the street delivery walk (e.g.: Hamilton HM 12) or the PO Box number range (e.g.: Hamilton HM BX). See Postal codes in Bermuda.",
    Country: "Bermuda",
    ISO: "BM",
    Format: "AA NN or AA AA",
    Regex: "^[A-Za-z]{2}\\s([A-Za-z]{2}|\\d{2})$",
  },
  {
    Note: "",
    Country: "Bhutan",
    ISO: "BT",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Bolivia",
    ISO: "BO",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Bonaire, Sint Eustatius and Saba",
    ISO: "BQ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Bosnia and Herzegovina",
    ISO: "BA",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Botswana",
    ISO: "BW",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Código de Endereçamento Postal (CEP): -000 to -899 are used for streets, roads, avenues, boulevards; -900 to -959 are used for buildings with a high postal use; -960 to -969 are for promotional use; -970 to -989 are post offices and regular P.O. boxes; and -990 to -998 are used for community P.O. boxes. -999 is used for special services.",
    Country: "Brazil",
    ISO: "BR",
    Format: "NNNNN-NNN (NNNNN from 1971 to 1992)",
    Regex: "^\\d{5}-\\d{3}$",
  },
  {
    Note: "Single code used for all addresses.",
    Country: "British Antarctic Territory",
    ISO: "",
    Format: "BIQQ 1ZZ",
    Regex: "^[Bb][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note: "UK territory, but not UK postcode.",
    Country: "British Indian Ocean Territory",
    ISO: "IO",
    Format: "AAAANAA one code: BBND 1ZZ",
    Regex: "^[Bb]{2}[Nn][Dd]\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note: "Specifically, VG1110 through VG1160[1]",
    Country: "British Virgin Islands",
    ISO: "VG",
    Format: "CCNNNN",
    Regex: "^[Vv][Gg]\\d{4}$",
  },
  {
    Note: "",
    Country: "Brunei",
    ISO: "BN",
    Format: "AANNNN",
    Regex: "^[A-Za-z]{2}\\d{4}$",
  },
  {
    Note: "",
    Country: "Bulgaria",
    ISO: "BG",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Burkina Faso",
    ISO: "BF",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Burundi",
    ISO: "BI",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Cambodia",
    ISO: "KH",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Cameroon",
    ISO: "CM",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "The system was gradually introduced starting in April 1971 in Ottawa. The letters D, F, I, O, Q, and U are not used to avoid confusion with other letters or numbers.",
    Country: "Canada",
    ISO: "CA",
    Format: "ANA NAN",
    Regex:
      "^(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\s{0,1}\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d$",
  },
  {
    Note: "The first digit indicates the island.",
    Country: "Cape Verde",
    ISO: "CV",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Cayman Islands",
    ISO: "KY",
    Format: "CCN-NNNN",
    Regex: "^[Kk][Yy]\\d[-\\s]{0,1}\\d{4}$",
  },
  {
    Note: "",
    Country: "Central African Republic",
    ISO: "CF",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Chad",
    ISO: "TD",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "May only be required for bulk mail.",
    Country: "Chile",
    ISO: "CL",
    Format: "NNNNNNN (NNN-NNNN)",
    Regex: "^\\d{7}\\s\\(\\d{3}-\\d{4}\\)$",
  },
  {
    Note:
      "A postal code or youbian (邮编) in a subordinate division will have the same first two digits as its governing one (see Political divisions of China. The postal services in Macau or Hong Kong Special Administrative Regions remain separate from Mainland China, with no post code system currently used.",
    Country: "China",
    ISO: "CN",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "Part of the Australian postal code system.",
    Country: "Christmas Island",
    ISO: "CX",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "Part of the Australian postal code system.",
    Country: "Cocos (Keeling) Island",
    ISO: "CC",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "First NN = 32 departments Códigos Postales | 4-72",
    Country: "Colombia",
    ISO: "CO",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "",
    Country: "Comoros",
    ISO: "KM",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Congo (Brazzaville)",
    ISO: "CG",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Congo, Democratic Republic",
    ISO: "CD",
    Format: "- no codes -",
    Regex: "^[Cc][Dd]$",
  },
  {
    Note: "",
    Country: "Cook Islands",
    ISO: "CK",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "First codes the provinces, next two the canton, last two the district.",
    Country: "Costa Rica",
    ISO: "CR",
    Format: "NNNNN (NNNN until 2007)",
    Regex: "^\\d{4,5}$",
  },
  {
    Note: "",
    Country: "Côte d'Ivoire (Ivory Coast)",
    ISO: "CI",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Croatia",
    ISO: "HR",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      'May only be required for bulk mail. The letters CP are frequently used before the postal code. This is not a country code, but an abbreviation for "codigo postal" or postal code.',
    Country: "Cuba",
    ISO: "CU",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Curaçao",
    ISO: "CW",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Post code system covers whole island, but not used in Northern Cyprus where 'Mersin 10, Turkey' is used instead.",
    Country: "Cyprus",
    ISO: "CY",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note:
      "With Slovak Republic, Poštovní směrovací číslo (PSČ) - postal routing number.",
    Country: "Czech Republic",
    ISO: "CZ",
    Format: "NNNNN (NNN NN)",
    Regex: "^\\d{5}$|^\\d{3} \\d{2}$",
  },
  {
    Note:
      "Numbering follows the dispatch of postal trains from Copenhagen.[3] Also used by Greenland, e.g.: DK-3900 Nuuk.",
    Country: "Denmark",
    ISO: "DK",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Djibouti",
    ISO: "DJ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Dominica",
    ISO: "DM",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Dominican Republic",
    ISO: "DO",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "No postal code system in use since Indonesian withdrawal in 1999.",
    Country: "East Timor",
    ISO: "TL",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Ecuador",
    ISO: "EC",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note:
      "Used for all inbound mail to El Salvador. The postal office then distributes the mail internally depending on their destination.",
    Country: "El Salvador",
    ISO: "SV",
    Format: "1101",
    Regex: "^1101$",
  },
  {
    Note: "",
    Country: "Egypt",
    ISO: "EG",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Equatorial Guinea",
    ISO: "GQ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Eritrea",
    ISO: "ER",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Estonia",
    ISO: "EE",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "The code is only used on a trial basis for Addis Ababa addresses.",
    Country: "Ethiopia",
    ISO: "ET",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "UK territory, but not UK postcode",
    Country: "Falkland Islands",
    ISO: "FK",
    Format: "AAAANAA one code: FIQQ 1ZZ",
    Regex: "^[Ff][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note:
      "Self-governing territory within the Kingdom of Denmark, but not Danish postcode.",
    Country: "Faroe Islands",
    ISO: "FO",
    Format: "NNN",
    Regex: "^\\d{3}$",
  },
  {
    Note: "",
    Country: "Fiji",
    ISO: "FJ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      'A lower first digit indicates a place in south (for example 00100 Helsinki), a higher indicates a place further to north (99800 in Ivalo). The last digit is usually 0, except for postal codes for PO Box number ranges, in which case it is 1. Country code for Finland: "FI". In the Åland Islands, the postal code is prefixed with "AX", not "FI". Some postal codes for rural settlements may end with 5, and there are some unique postal codes for large companies and institutions, e.g. 00014 HELSINGIN YLIOPISTO (university), 00102 EDUSKUNTA (parliament), 00020 NORDEA (a major Scandinavian bank).',
    Country: "Finland",
    ISO: "FI",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      'The first two digits give the département number, while in Paris, Lyon and Marseille, the last two digits of the postal code indicates the arrondissement. Both of the 2 corsican départements use "20" as the first two digits. Also used by French overseas departments and territories. Monaco is also part of the French postal code system, but the country code MC- is used for Monegasque addresses.',
    Country: "France",
    ISO: "FR",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 97300 - 97390.",
    Country: "French Guiana",
    ISO: "GF",
    Format: "973NN",
    Regex: "^973\\d{2}$",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 98700 - 98790.",
    Country: "French Polynesia",
    ISO: "PF",
    Format: "987NN",
    Regex: "^987\\d{2}$",
  },
  {
    Note: "French codes in the 98400 range have been reserved.",
    Country: "French Southern and Antarctic Territories",
    ISO: "TF",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Two digit postal zone goes after city name.",
    Country: "Gabon",
    ISO: "GA",
    Format: "NN [city name] NN",
    Regex: "^\\d{2}\\s[a-zA-Z-_ ]\\s\\d{2}$",
  },
  {
    Note: "",
    Country: "Gambia",
    ISO: "GM",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Georgia",
    ISO: "GE",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note:
      'Postleitzahl (PLZ), introduced after the German reunification. Between 1989 and 1993 the old separate 4-digit postal codes of former West- and East-Germany were distinguished by preceding "W-" or "O-" (\'Ost\' for East).',
    Country: "Germany",
    ISO: "DE",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "[citation needed]",
    Country: "Ghana",
    ISO: "GH",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Single code used for all addresses.",
    Country: "Gibraltar",
    ISO: "GI",
    Format: "GX11 1AA",
    Regex: "^[Gg][Xx][1]{2}\\s{0,1}[1][Aa]{2}$",
  },
  {
    Note: "",
    Country: "Greece",
    ISO: "GR",
    Format: "NNN NN",
    Regex: "^\\d{3}\\s{0,1}\\d{2}$",
  },
  {
    Note: "Part of the Danish postal code system.",
    Country: "Greenland",
    ISO: "GL",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Grenada",
    ISO: "GD",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 97100 - 97190.",
    Country: "Guadeloupe",
    ISO: "GP",
    Format: "971NN",
    Regex: "^971\\d{2}$",
  },
  {
    Note: "U.S. ZIP codes. Range 96910 - 96932.",
    Country: "Guam",
    ISO: "GU",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "The first two numbers identify the department, the third number the route and the last two the office.",
    Country: "Guatemala",
    ISO: "GT",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "UK-format postcode (first two letters are always GY not GG)",
    Country: "Guernsey",
    ISO: "GG",
    Format: "AAN NAA, AANN NAA",
    Regex: "^[A-Za-z]{2}\\d\\s{0,1}\\d[A-Za-z]{2}$",
  },
  {
    Note: "",
    Country: "Guinea",
    ISO: "GN",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Guinea Bissau",
    ISO: "GW",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Guyana",
    ISO: "GY",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Haiti",
    ISO: "HT",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "Part of the Australian postcode system.",
    Country: "Heard and McDonald Islands",
    ISO: "HM",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Honduras",
    ISO: "HN",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "[1] The dummy postal code of Hong Kong is 999077 but it is unnecessary in fact",
    Country: "Hong Kong",
    ISO: "HK",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "The code defines an area, usually one code per settlement except the six largest towns. One code can identify more (usually) small settlements as well.",
    Country: "Hungary",
    ISO: "HU",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Iceland",
    ISO: "IS",
    Format: "NNN",
    Regex: "^\\d{3}$",
  },
  {
    Note: "Postal Index Number (PIN)",
    Country: "India",
    ISO: "IN",
    Format: "NNNNNN,&#10;NNN NNN",
    Regex: "^\\d{6}$",
  },
  {
    Note:
      "Kode Pos. Included East Timor (ranges 88xxx and 89xxx) until 1999, no longer used. For Indonesia postal code information visit [2]",
    Country: "Indonesia",
    ISO: "ID",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "(Persian: کد پستی)",
    Country: "Iran",
    ISO: "IR",
    Format: "NNNNN-NNNNN",
    Regex: "^\\d{5}-\\d{5}$",
  },
  {
    Note: "",
    Country: "Iraq",
    ISO: "IQ",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "Currently no postal codes; however, Dublin is divided into postal districts on syntax Dublin 9. A national post code system is planned. See also Republic of Ireland postal addresses.",
    Country: "Ireland",
    ISO: "IE",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "UK-format postcode. The first two letters are always IM.",
    Country: "Isle of Man",
    ISO: "IM",
    Format: "CCN NAA, CCNN NAA",
    Regex: "^[Ii[Mm]\\d{1,2}\\s\\d\\[A-Z]{2}$",
  },
  {
    Note:
      "Postcode is always written BEFORE the city/place name, i.e. to the Right in Hebrew or Arabic script - to the Left in Latin script.  This also allows the legacy postal code version (even though deprecated) since it's still in high use.",
    Country: "Israel",
    ISO: "IL",
    Format: "NNNNNNN, NNNNN",
    Regex: "^\\b\\d{5}(\\d{2})?$",
  },
  {
    Note:
      "Codice di Avviamento Postale (CAP). Also used by San Marino and Vatican City. First two digits identify province with some exceptions, because there are more than 100 provinces.",
    Country: "Italy",
    ISO: "IT",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "Jamaica currently has no national postal code system, except for Kingston and Lower St. Andrew, which are divided into postal districts numbered 1-20[4] &#10;Before the 2007 suspension, the first two letters of a national post code were always 'JM' (for Jamaica) while the third was for one of the four zones (A-D) into which the island was divided. The last two letters were for the parish, while the two digits were for the local post office.[5]",
    Country: "Jamaica",
    ISO: "JM",
    Format: "Before suspension: CCAAANN &#10;After suspension: NN",
    Regex: "^\\d{2}$",
  },
  {
    Note: "See also Japanese addressing system.",
    Country: "Japan",
    ISO: "JP",
    Format: "NNNNNNN (NNN-NNNN)",
    Regex: "^〒?[0-9]{3}-?[0-9]{4}$",
  },
  {
    Note: "UK-format postcode.",
    Country: "Jersey",
    ISO: "JE",
    Format: "CCN NAA",
    Regex: "^[Jj][Ee]\\d\\s{0,1}\\d[A-Za-z]{2}$",
  },
  {
    Note: "Deliveries to PO Boxes only.",
    Country: "Jordan",
    ISO: "JO",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "[6]",
    Country: "Kazakhstan",
    ISO: "KZ",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note:
      "Deliveries to PO Boxes only. The postal code refers to the post office at which the receiver's P. O. Box is located.",
    Country: "Kenya",
    ISO: "KE",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Kiribati",
    ISO: "KI",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Korea, North",
    ISO: "KP",
    Format: "- no codes -",
    Regex: "",
  },

  {
    Note:
      "A separate postal code for Kosovo was introduced by the UNMIK postal administration in 2004. Serbian postcodes are still widely used in the Serbian enclaves. No country code has been assigned.",
    Country: "Kosovo",
    ISO: "XK",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "The first two digits represent the sector and the last three digits represents the post office.",
    Country: "Kuwait",
    ISO: "KW",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Kyrgyzstan",
    ISO: "KG",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "",
    Country: "Latvia",
    ISO: "LV",
    Format: "LV-NNNN",
    Regex: "^[Ll][Vv][- ]{0,1}\\d{4}$",
  },
  {
    Note: "",
    Country: "Laos",
    ISO: "LA",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "The first four digits represent the region or postal zone,the last four digits represent the building see also Lebanon Postal code website.",
    Country: "Lebanon",
    ISO: "LB",
    Format: "NNNN NNNN",
    Regex: "^\\d{4}\\s{0,1}\\d{4}$",
  },
  {
    Note: "",
    Country: "Lesotho",
    ISO: "LS",
    Format: "NNN",
    Regex: "^\\d{3}$",
  },
  {
    Note: "Two digit postal zone after city name.",
    Country: "Liberia",
    ISO: "LR",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Libya",
    ISO: "LY",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "With Switzerland, ordered from west to east. Range 9485 - 9498.",
    Country: "Liechtenstein",
    ISO: "LI",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note:
      "References: http://www.post.lt/en/help/postal-code-search. Previously 9999 which was actually the old Soviet 999999 format code with the first 2 digits dropped.",
    Country: "Lithuania",
    ISO: "LT",
    Format: "LT-NNNNN",
    Regex: "^[Ll][Tt][- ]{0,1}\\d{5}$",
  },
  {
    Note: "References: http://www.upu.int/post_code/en/countries/LUX.pdf",
    Country: "Luxembourg",
    ISO: "LU",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "[2]",
    Country: "Macau",
    ISO: "MO",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Macedonia",
    ISO: "MK",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Madagascar",
    ISO: "MG",
    Format: "NNN",
    Regex: "^\\d{3}$",
  },
  {
    Note: "",
    Country: "Malawi",
    ISO: "MW",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Maldives",
    ISO: "MV",
    Format: "NNNN, NNNNN",
    Regex: "^\\d{4,5}$",
  },
  {
    Note: "",
    Country: "Malaysia",
    ISO: "MY",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Mali",
    ISO: "ML",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Kodiċi Postali",
    Country: "Malta",
    ISO: "MT",
    Format: "AAANNNN (AAA NNNN)",
    Regex: "^[A-Za-z]{3}\\s{0,1}\\d{4}$",
  },
  {
    Note: "U.S. ZIP codes. Range 96960 - 96970.",
    Country: "Marshall Islands",
    ISO: "MH",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Mauritania",
    ISO: "MR",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Mauritius",
    ISO: "MU",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 97200 - 97290.",
    Country: "Martinique",
    ISO: "MQ",
    Format: "972NN",
    Regex: "^972\\d{2}$",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 97600 - 97690.",
    Country: "Mayotte",
    ISO: "YT",
    Format: "976NN",
    Regex: "^976\\d{2}$",
  },
  {
    Note: "US ZIP Code. Range 96941 - 96944.",
    Country: "Micronesia",
    ISO: "FM",
    Format: "NNNNN or NNNNN-NNNN",
    Regex: "^\\d{5}(-{1}\\d{4})$",
  },
  {
    Note:
      "The first two digits identify the state (or a part thereof), except for Nos. 00 to 16, which indicate delegaciones (boroughs) of the Federal District (Mexico City).",
    Country: "Mexico",
    ISO: "MX",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Moldova",
    ISO: "MD",
    Format: "CCNNNN (CC-NNNN)",
    Regex: "^[Mm][Dd][- ]{0,1}\\d{4}$",
  },
  {
    Note: 'Uses the French Postal System, but with an "MC" Prefix for Monaco.',
    Country: "Monaco",
    ISO: "MC",
    Format: "980NN",
    Regex: "^980\\d{2}$",
  },
  {
    Note:
      "First digit: region / zone&#10;Second digit: province / district&#10;Last three digits: locality / delivery block[7]",
    Country: "Mongolia",
    ISO: "MN",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Montenegro",
    ISO: "ME",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Montserrat",
    ISO: "MS",
    Format: "MSR 1110-1350",
    Regex: "^[Mm][Ss][Rr]\\s{0,1}\\d{4}$",
  },
  {
    Note: "",
    Country: "Morocco",
    ISO: "MA",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Mozambique",
    ISO: "MZ",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Myanmar",
    ISO: "MM",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "Postal Code ranges from 9000-9299 (NOTE: mainly 9000 is used)",
    Country: "Namibia",
    ISO: "NA",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Nauru",
    ISO: "NR",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Nepal",
    ISO: "NP",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      "The combination of the postcode and the housenumber gives a unique identifier of the address.",
    Country: "Netherlands",
    ISO: "NL",
    Format: "NNNN AA",
    Regex: "^\\d{4}\\s{0,1}[A-Za-z]{2}$",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 98800 - 98890.",
    Country: "New Caledonia",
    ISO: "NC",
    Format: "988NN",
    Regex: "^988\\d{2}$",
  },
  {
    Note:
      "Postcodes were originally intended for bulk mailing and were not needed for addressing individual items. However, new post codes for general use were phased in from June 2006 and came into force by July 2008.",
    Country: "New Zealand",
    ISO: "NZ",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Nicaragua",
    ISO: "NI",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Niger",
    ISO: "NE",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Nigeria",
    ISO: "NG",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "",
    Country: "Niue",
    ISO: "NU",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Part of the Australian postal code system.",
    Country: "Norfolk Island",
    ISO: "NF",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "U.S. ZIP codes. Range 96950 - 96952.",
    Country: "Northern Mariana Islands",
    ISO: "MP",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "From south to north",
    Country: "Norway",
    ISO: "NO",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "Deliveries to P.O. Boxes only.",
    Country: "Oman",
    ISO: "OM",
    Format: "NNN",
    Regex: "^\\d{3}$",
  },
  {
    Note: "Pakistan postal codes list",
    Country: "Pakistan",
    ISO: "PK",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "U.S. ZIP codes. All locations 96940.",
    Country: "Palau",
    ISO: "PW",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Panama",
    ISO: "PA",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "",
    Country: "Papua New Guinea",
    ISO: "PG",
    Format: "NNN",
    Regex: "^\\d{3}$",
  },
  {
    Note: "",
    Country: "Paraguay",
    ISO: "PY",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "",
    Country: "Peru",
    ISO: "PE",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Philippines",
    ISO: "PH",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "UK territory, but not UK postcode",
    Country: "Pitcairn Islands",
    ISO: "PN",
    Format: "AAAANAA one code: PCRN 1ZZ",
    Regex: "^[Pp][Cc][Rr][Nn]\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note: "",
    Country: "Poland",
    ISO: "PL",
    Format: "NNNNN (NN-NNN)",
    Regex: "^\\d{2}[- ]{0,1}\\d{3}$",
  },
  {
    Note: "",
    Country: "Portugal",
    ISO: "PT",
    Format: "NNNN-NNN (NNNN NNN)",
    Regex: "^\\d{4}[- ]{0,1}\\d{3}$",
  },
  {
    Note:
      "U.S. ZIP codes. ZIP codes 006XX for NW PR, 007XX for SE PR, in which XX designates the town or post office and 009XX for the San Juan Metropolitan Area, in which XX designates the area or borough of San Juan. The last four digits identify an area within the post office. For example 00716-2604: 00716-for the east section of the city of Ponce and 2604 for Aceitillo St. in the neighborhood of Los Caobos. US Post office is changing the PR address format to the American one: 1234 No Name Avenue, San Juan, PR 00901.",
    Country: "Puerto Rico",
    ISO: "PR",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Qatar",
    ISO: "QA",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 97400 - 97490.",
    Country: "Réunion",
    ISO: "RE",
    Format: "974NN",
    Regex: "^974\\d{2}$",
  },
  {
    Note: "Previously 99999 in Bucharest and 9999 in rest of country.",
    Country: "Romania",
    ISO: "RO",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "Placed on a line of its own.",
    Country: "Russia",
    ISO: "RU",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "Overseas Collectivity of France. French codes used.",
    Country: "Saint Barthélemy",
    ISO: "BL",
    Format: "97133",
    Regex: "^97133$",
  },
  {
    Note: "Single code used for all addresses.",
    Country: "Saint Helena",
    ISO: "SH",
    Format: "STHL 1ZZ",
    Regex: "^[Ss][Tt][Hh][Ll]\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note: "",
    Country: "Saint Kitts and Nevis",
    ISO: "KN",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Saint Lucia",
    ISO: "LC",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "Overseas Collectivity of France. French codes used.",
    Country: "Saint Martin",
    ISO: "MF",
    Format: "97150",
    Regex: "^97150$",
  },
  {
    Note: "Overseas Collectivity of France. French codes used.",
    Country: "Saint Pierre and Miquelon",
    ISO: "PM",
    Format: "97500",
    Regex: "^97500$",
  },
  {
    Note: "",
    Country: "Saint Vincent and the Grenadines",
    ISO: "VC",
    Format: "CCNNNN",
    Regex: "^[Vv][Cc]\\d{4}$",
  },
  {
    Note:
      "With Italy, uses a five-digit numeric CAP of Emilia Romagna. Range 47890 and 47899",
    Country: "San Marino",
    ISO: "SM",
    Format: "4789N",
    Regex: "^4789\\d$",
  },
  {
    Note: "",
    Country: "Sao Tome and Principe",
    ISO: "ST",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "A complete 13-digit code has 5-digit number representing region, sector, city, and zone; 4-digit X between 2000 and 5999; 4-digit Y between 6000 and 9999 [3]. Digits of 5-digit code may represent postal region, sector, branch, section, and block respectively [4].",
    Country: "Saudi Arabia",
    ISO: "SA",
    Format: "NNNNN for PO Boxes. NNNNN-NNNN for home delivery.",
    Regex: "^\\d{5}(-{1}\\d{4})?$",
  },
  {
    Note:
      'The letters CP or C.P. are often written in front of the postcode. This is not a country code, but simply an abbreviation for "code postal".',
    Country: "Senegal",
    ISO: "SN",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Serbia",
    ISO: "RS",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Seychelles",
    ISO: "SC",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Sint Maarten",
    ISO: "SX",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Sierra Leone",
    ISO: "SL",
    Format: "- no codes -",
    Regex: "",
  },

  {
    Note: "Each building has its own unique postcode.",
    Country: "Singapore",
    ISO: "SG",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note:
      "with Czech Republic from west to east, Poštové smerovacie číslo (PSČ) - postal routing number.",
    Country: "Slovakia",
    ISO: "SK",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Slovenia",
    ISO: "SI",
    Format: "NNNN (CC-NNNN)",
    Regex: "^([Ss][Ii][- ]{0,1}){0,1}\\d{4}$",
  },
  {
    Note: "",
    Country: "Solomon Islands",
    ISO: "SB",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "A 5 digit code has been publicized, but never taken into use.",
    Country: "Somalia",
    ISO: "SO",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Postal codes are allocated to individual Post Office branches, some have two codes to differentiate between P.O. Boxes and street delivery addresses. Included Namibia (ranges 9000-9299) until 1992, no longer used.",
    Country: "South Africa",
    ISO: "ZA",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "One code for all addresses.",
    Country: "South Georgia and the South Sandwich Islands",
    ISO: "GS",
    Format: "SIQQ 1ZZ",
    Regex: "^[Ss][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note: "",
    Country: "South Korea",
    ISO: "KR",
    Format: "NNNNNN (NNN-NNN)",
    Regex: "^\\d{5}$",
  },
  {
    Note: "First two indicate the province, range 01-52",
    Country: "Spain",
    ISO: "ES",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note:
      'Reference: http://mohanjith.net/ZIPLook/ Incorporates Colombo postal districts, e.g.: Colombo 1 is "00100". You can search for specific postal codes here.',
    Country: "Sri Lanka",
    ISO: "LK",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Sudan",
    ISO: "SD",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Suriname",
    ISO: "SR",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "The letter identifies one of the country's four districts.",
    Country: "Swaziland",
    ISO: "SZ",
    Format: "ANNN",
    Regex: "^[A-Za-z]\\d{3}$",
  },
  {
    Note: "",
    Country: "Sweden",
    ISO: "SE",
    Format: "NNNNN (NNN NN)",
    Regex: "^\\d{3}\\s*\\d{2}$",
  },
  {
    Note:
      "With Liechtenstein, ordered from west to east. In Geneva and other big cities, like Basel, Bern, Zurich, there may be one or two digits after the name of the city when the generic City code (1211) is used instead of the area-specific code (1201, 1202...), e.g.: 1211 Geneva 13. The digit identifies the post office. This addressing is generally used for P.O. box deliveries.",
    Country: "Switzerland",
    ISO: "CH",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "Norway postal codes",
    Country: "Svalbard and Jan Mayen",
    ISO: "SJ",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "A 4-digit system has been announced. Status unknown.",
    Country: "Syria",
    ISO: "SY",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "The first three digits of the postal code are required; the last two digits are optional. Codes are known as youdi quhao (郵遞區號), and are also assigned to Senkaku Islands (Diaoyutai), though Japanese-administered, the Pratas Islands and the Spratly Islands. See List of postal codes in Taiwan.",
    Country: "Taiwan",
    ISO: "TW",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "Retained system from former Soviet Union.",
    Country: "Tajikistan",
    ISO: "TJ",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "",
    Country: "Tanzania",
    ISO: "TZ",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "The first two specify the province, numbers as in ISO 3166-2:TH, the third and fourth digits specify a district (amphoe)",
    Country: "Thailand",
    ISO: "TH",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "Togo",
    ISO: "TG",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Tokelau",
    ISO: "TK",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Tonga",
    ISO: "TO",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "First two digits specify a postal district (one of 72), next two digits a carrier route, last two digits a building or zone along that route",
    Country: "Trinidad and Tobago",
    ISO: "TT",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "",
    Country: "Tunisia",
    ISO: "TN",
    Format: "NNNN",
    Regex: "^\\d{4}$",
  },
  {
    Note: "First two digits are the city numbers.[8]",
    Country: "Turkey",
    ISO: "TR",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "Retained system from former Soviet Union.",
    Country: "Turkmenistan",
    ISO: "TM",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note: "Single code used for all addresses.",
    Country: "Turks and Caicos Islands",
    ISO: "TC",
    Format: "TKCA 1ZZ",
    Regex: "^[Tt][Kk][Cc][Aa]\\s{0,1}[1][Zz]{2}$",
  },
  {
    Note: "",
    Country: "Tuvalu",
    ISO: "TV",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Uganda",
    ISO: "UG",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Ukraine",
    ISO: "UA",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "",
    Country: "United Arab Emirates",
    ISO: "AE",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      'Known as the postcode. The first letter(s) indicate the postal area, such as the town or part of London. Placed on a separate line below the city (or county, if used). The UK postcode is made up of two parts separated by a space. These are known as the outward postcode and the inward postcode. The outward postcode is always one of the following formats: AN, ANN, AAN, AANN, ANA, AANA, AAA. The inward postcode is always formatted as NAA. A valid inward postcode never contains the letters: C, I, K, M, O or V. The British Forces Post Office has a different system, but as of 2012 has also adopted UK-style postcodes that begin with "BF1" for electronic compatibility.',
    Country: "United Kingdom",
    ISO: "GB",
    Format: "A(A)N(A/N)NAA (A[A]N[A/N] NAA)",
    Regex: "^([A-Z][A-HJ-Y]?[0-9][A-Z0-9]? ?[0-9][A-Z]{2}|GIR ?0A{2})$",
  },
  {
    Note:
      "Known as the ZIP Code with five digits 99999* or the ZIP+4 Code with nine digits 99999-9999* (while the minimum requirement is the first five digits, the U.S. Postal Service encourages everyone to use all nine). Also used by the former US Pacific Territories: Federated States of Micronesia; Palau; and the Marshall Islands, as well as in current US territories American Samoa, Guam, Northern Mariana Islands, Puerto Rico, and the United States Virgin Islands. An individual delivery point may be represented as an 11-digit number, but these are usually represented by Intelligent Mail barcode or formerly POSTNET bar code.",
    Country: "United States",
    ISO: "US",
    Format: "NNNNN (optionally NNNNN-NNNN)",
    Regex: "^\\b\\d{5}\\b(?:[- ]{1}\\d{4})?$",
  },
  {
    Note: "",
    Country: "Uruguay",
    ISO: "UY",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "U.S. ZIP codes. Range 00801 - 00851.",
    Country: "U.S. Virgin Islands",
    ISO: "VI",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "Почтовые индексы",
    Country: "Uzbekistan",
    ISO: "UZ",
    Format: "NNN NNN",
    Regex: "^\\d{3} \\d{3}$",
  },
  {
    Note: "",
    Country: "Vanuatu",
    ISO: "VU",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note:
      "Single code used for all addresses. Part of the Italian postal code system.",
    Country: "Vatican",
    ISO: "VA",
    Format: "120",
    Regex: "^120$",
  },
  {
    Note: "",
    Country: "Venezuela",
    ISO: "VE",
    Format: "NNNN or NNNN A",
    Regex: "^\\d{4}(\\s[a-zA-Z]{1})?$",
  },
  {
    Note: "First two indicate a province.",
    Country: "Vietnam",
    ISO: "VN",
    Format: "NNNNNN",
    Regex: "^\\d{6}$",
  },
  {
    Note:
      "Overseas Department of France. French codes used. Range 98600 - 98690.",
    Country: "Wallis and Futuna",
    ISO: "WF",
    Format: "986NN",
    Regex: "^986\\d{2}$",
  },
  {
    Note:
      'System for Sana\'a Governorate using geocoding "عنواني" based on the OpenPostcode algorithm is inaugurated in 2014.[9]',
    Country: "Yemen",
    ISO: "YE",
    Format: "- no codes -",
    Regex: "",
  },
  {
    Note: "",
    Country: "Zambia",
    ISO: "ZM",
    Format: "NNNNN",
    Regex: "^\\d{5}$",
  },
  {
    Note: "System is being planned.",
    Country: "Zimbabwe",
    ISO: "ZW",
    Format: "- no codes -",
    Regex: "",
  },
]
export const Countries = new Map(
  cList.map(c => {
    const pValidation = postalValidation.find(p => p.ISO === c.alpha2)
    return [
      c.name,
      {
        name: c.name,
        code: c.alpha2,
        postalRegex: pValidation?.Regex ?? "",
        postalFormat: pValidation?.Format ?? "",
        countryCallingCodes: c.countryCallingCodes,
      },
    ]
  })
)
